export function getHumanReadableTime(time) {
  const [hours, minutes, seconds] = time.split(':').map(val => parseInt(val))
  const humanReadableResetTime = []
  if (hours > 0) humanReadableResetTime.push(`${hours} ${hours > 1 ? 'hours' : 'hour'}`)
  if (minutes > 0) humanReadableResetTime.push(`${minutes} ${minutes > 1 ? 'minutes' : 'minute'}`)
  if (seconds > 0) humanReadableResetTime.push(`${seconds} ${seconds > 1 ? 'seconds' : 'second'}`)

  // Create a natural readable message, like "1 hour, 10 minutes and 5 seconds"
  const combinedResetTime = [humanReadableResetTime.pop(), humanReadableResetTime.join(', ')]
    .filter(v => v)
    .reverse()
    .join(' and ')
  return combinedResetTime !== '' ? combinedResetTime : null
}
